import {defineMessages} from 'react-intl';

export default defineMessages({
	addToCart: {
		id: 'pdp.floatingButtons.addToCart',
		defaultMessage: 'Add to shopping bag',
	},
	notifyMe: {
		id: 'pdp.floatingButtons.notifyMe',
		defaultMessage: 'Notify me',
	},
	preOrderNow: {
		id: 'pdp.floatingButtons.preOrderNow',
		defaultMessage: 'Pre-order Now',
	},
	buyNow: {
		id: 'pdp.floatingButtons.buyNow',
		defaultMessage: 'buy now',
	},
	selectSize: {
		id: 'pdp.floatingButtons.selectSize',
		defaultMessage: 'select size',
	},
});
